import { calculateWeeksWorked } from '@utils/weeks'

export function calculateRate(client, candidate, weekEnding, jobTypeId) {

	const jobTypeRateObj = client.jobTypeRates.find(o => o.jobType === jobTypeId);

	const useAWR = (() => {
		if(client.AWRApplicable) {
			const startDate = candidate.clientStartDates.find(o => o.client === client._id).startDate;
			const weeksWorked = calculateWeeksWorked(startDate, weekEnding);
			if(weeksWorked >= 12) {
				return true;
			}
		}
		return false;
	})();

	if(!jobTypeRateObj) return 'Error: client missing job type rate';

	return jobTypeRateObj[useAWR ? 'AWR' : 'standard'].chargeRate;

}


// WEBPACK FOOTER //
// ./src/utils/rates.js